var $class="se2--navigation-customer-journey-with-cta",$name="NavigationCustomerJourneyWithCTA",$path="app/components/NavigationCustomerJourneyWithCTA/index.js",$this={$class,$name,$path,};import setInitialTabIndexes from 'app/components/NavigationCustomerJourney/utilities/setInitialTabIndexes';

import shell from 'app/modules/shell';
import initializeSticky from 'app/modules/sticky/initializeSticky';
import setStickyAnimation from 'app/modules/sticky/setStickyAnimation';

import isUsingKeyboard from 'app/utilities/isUsingKeyboard';
import switchFocusToTargetElement from 'app/utilities/switchFocusToTargetElement';

import { css, directions, keyNames, messages } from 'configs';

import Draggable from 'gsap/Draggable';
import gsap from 'gsap';

import { tabClassName, ctaButtonClassName } from './config';

const reducedClassName = 'navigation-reduced';
const tabsContainerClassName = 'tabs-container';
const tabsElementClassName = 'tabs';
const sliderOffset = 16;

export default shell.registerComponent($this, ({
  addEventListener, mount, settings, subscribeToMessage,
}) => {
  function onKeyDown({
    event,
    tabsContainer,
  }) {
    if (isUsingKeyboard()) {
      const { code, target, currentTarget: navElement } = event;
      const { tab } = keyNames;
      let { arrowRight, arrowLeft } = keyNames;

      if (settings.direction === directions.rtl) {
        arrowRight = keyNames.arrowLeft;
        arrowLeft = keyNames.arrowRight;
      }

      if (code === arrowRight) {
        event.preventDefault();
        const nextElement = target.parentNode.nextElementSibling;
        if (nextElement && !target.className.includes(ctaButtonClassName)) {
          const nextElementLink = nextElement.querySelector('a');
          switchFocusToTargetElement(nextElementLink, target);
          gsap.to(tabsContainer, { duration: 0, scrollTo: { x: nextElementLink } });
        }
      } else if (code === arrowLeft) {
        event.preventDefault();
        const previousElement = target.parentNode.previousElementSibling;
        if (previousElement && !target.className.includes(ctaButtonClassName)) {
          const prevElementLink = previousElement.querySelector('a');
          switchFocusToTargetElement(prevElementLink, target);
          gsap.to(tabsContainer, { duration: 0, scrollTo: { x: prevElementLink } });
        }
      } else if (code === tab) {
        const activeTab = navElement.querySelector(`.${css.classNames.active}`);
        if (activeTab) {
          const onFocusOut = ({ currentTarget }) => {
            setInitialTabIndexes(navElement, activeTab, tabClassName);
            currentTarget.removeEventListener('focusout', onFocusOut);
          };
          target.addEventListener('focusout', onFocusOut);
        }
      }
    }
  }

  const initDraggable = (element, tabsContainer) => {
    const tabsElement = element.querySelector(`.${tabsElementClassName}`);

    const setSliderWidth = () => {
      // non-logical style is used in order to correctly perform with gsap
      tabsElement.style.width = 'auto';
      tabsElement.style.width = `${tabsElement.scrollWidth}px`;
    };

    setSliderWidth();
    addEventListener(window, 'resize', setSliderWidth);
    addEventListener(window, 'load', setSliderWidth);

    return {
      draggable: new Draggable(
        tabsElement,
        {
          allowContextMenu: true,
          bounds: tabsContainer,
          cursor: 'default',
          activeCursor: 'drag',
          dragClickables: true,
          throwProps: true,
          type: 'x',
          zIndexBoost: false,
        },
      ),
    };
  };

  const defineActiveTab = (element, tabsContainer) => {
    let { pathname } = window.location;
    if (pathname.endsWith('/')) pathname = pathname.slice(0, -1);

    const pathnameWithIndex = `${pathname}/index.jsp`;

    const linkOfActiveTab = element.querySelectorAll(
      (`li a[href*="${pathname}"]`), (`li a[href*="${pathnameWithIndex}"]`),
    )[0];
    if (linkOfActiveTab) {
      const activeTab = linkOfActiveTab.parentElement;
      activeTab.classList.add(css.classNames.active);
      setInitialTabIndexes(element, activeTab, tabClassName);

      gsap.to(tabsContainer, { duration: 0, scrollTo: { x: activeTab, offsetX: sliderOffset } });
    } else {
      setInitialTabIndexes(element, element.querySelector(`.${tabClassName}`), tabClassName);
    }
  };

  mount((element) => {
    const tabsContainer = element.querySelector(`.${tabsContainerClassName}`);

    initializeSticky(element);
    setStickyAnimation(element, element.previousElementSibling, subscribeToMessage);

    initDraggable(element, tabsContainer);
    defineActiveTab(element, tabsContainer);

    addEventListener(
      element,
      'keydown',
      (event) => onKeyDown({
        event,
        tabsContainer,
      }),
    );

    const setHeaderHeight = (isReduced) => {
      element.classList.toggle(reducedClassName, isReduced);
    };

    subscribeToMessage(messages.headerHeight, setHeaderHeight);
  });
});
